module.exports = __webpack_public_path__ + "img/Google_Maps-Logo.68ebe63e.svg";